<p-toast></p-toast>

<h2 class="page-title">
  {{ "i18n.domain.subscription.overview.title" | translate }}
</h2>

<div class="data-table">
  <p-toolbar>
    <ng-template pTemplate="left">
      <p-button
        label="{{ 'i18n.domain.subscription.overview.add' | translate }}"
        icon="pi pi-plus"
        (onClick)="openNew()"
      ></p-button>
    </ng-template>
    <ng-template pTemplate="right">
      <app-search-field
        (searchTextChanged)="onSearchTextChanged($event)"
      ></app-search-field>
    </ng-template>
  </p-toolbar>

  <p-table
    [value]="data"
    [rows]="pagedQuery.pageSize"
    [paginator]="true"
    [globalFilterFields]="globalFilters"
    [rowHover]="true"
    dataKey="id"
    [lazy]="true"
    (onFilter)="onFilter($event)"
    (onPage)="onPageChange($event)"
    (onSort)="onSort($event)"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Subscriptions"
    [showCurrentPageReport]="true"
    [totalRecords]="totalNoOfRecords"
    [rowsPerPageOptions]="pagedQuery.getPageSizes()"
    [filterDelay]="0"
    [filters]="columnFilters"
    styleClass="dt-grid"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name">
          {{ "i18n.domain.subscription.fields.name" | translate }}
          <p-sortIcon field="name"></p-sortIcon>
          <p-columnFilter
            type="text"
            field="name"
            display="menu"
            [matchModeOptions]="filterMatchModeOptions"
          >
          </p-columnFilter>
        </th>

        <th pSortableColumn="price" class="dt-num">
          {{ "i18n.domain.subscription.fields.price" | translate }} (₹)
          <p-sortIcon field="price"></p-sortIcon>
          <p-columnFilter type="numeric" field="price" display="menu">
          </p-columnFilter>
        </th>

        <th pSortableColumn="type">
          {{ "i18n.domain.subscription.fields.Type" | translate }}
          <p-sortIcon field="type"></p-sortIcon>
          <p-columnFilter type="text" field="type" display="menu">
          </p-columnFilter>
        </th>

        <th pSortableColumn="priceType" class="col-price-type">
          {{ "i18n.domain.subscription.fields.priceType" | translate }}
          <p-sortIcon field="priceType"></p-sortIcon>
          <p-columnFilter type="text" field="priceType" display="menu">
          </p-columnFilter>
        </th>

        <th pSortableColumn="isActive" class="dt-narrow">
          {{ "i18n.domain.subscription.fields.status" | translate }}
          <p-sortIcon field="isActive"></p-sortIcon>
          <p-columnFilter type="boolean" field="isActive" display="menu">
          </p-columnFilter>
        </th>

        <th class="dt-actions-wide"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-subscription>
      <tr>
        <td>{{ subscription.name }}</td>
        <td class="dt-num">{{ subscription.price }}</td>

        <td>{{ subscription.type === 0 ? "Individual" : "Business" }}</td>

        <td class="col-price-type">
          {{
            subscription.priceType === 0
              ? "Monthly"
              : subscription.priceType === 1
                ? "Annually"
                : "OneTime"
          }}
        </td>

        <td class="dt-narrow">
          <p-tag
            [value]="subscription.isActive ? 'Yes' : 'No'"
            [severity]="subscription.isActive ? 'success' : 'danger'"
          ></p-tag>
        </td>

        <td class="dt-actions-wide">
          <div class="grid-commands">
            <p-button
              icon="pi pi-users"
              [rounded]="true"
              [outlined]="true"
              severity="info"
              (onClick)="viewUsers(subscription)"
            ></p-button>
            <p-button
              icon="pi pi-pencil"
              [rounded]="true"
              [outlined]="true"
              severity="success"
              (onClick)="editItem(subscription)"
            ></p-button>
            <p-button
              icon="pi pi-trash"
              [rounded]="true"
              [outlined]="true"
              severity="danger"
              (onClick)="deleteSubscription(subscription)"
            ></p-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="6">No Subscriptions found</td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog
    [(visible)]="itemDialog"
    [style]="{ width: '500px' }"
    [modal]="true"
    styleClass="p-fluid"
  >
    <ng-template pTemplate="header">
      <div class="dialog-header">
        <span class="dialog-title">
          {{
            "i18n.domain.subscription.overview.edit-dialog-title" | translate
          }}
        </span>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <form [formGroup]="form" class="p-fluid">
        <div class="field">
          <label for="name" class="control-label required">
            {{ "i18n.domain.subscription.fields.name" | translate }}
          </label>
          <input id="name" pInputText formControlName="name" />
        </div>

        <div class="field">
          <label for="description" class="control-label required">
            {{ "i18n.domain.subscription.fields.description" | translate }}
          </label>
          <input id="description" pInputText formControlName="description" />

          <small> {{ formControls.description.value?.length || 0 }}/200 </small>
        </div>

        <div class="field">
          <label for="price" class="control-label required">
            {{ "i18n.domain.subscription.fields.price" | translate }} (₹)
          </label>
          <input
            id="price"
            pInputText
            type="number"
            formControlName="price"
            min="0"
          />
        </div>

        <div class="field">
          <label for="type" class="control-label required">
            {{ "i18n.domain.subscription.fields.Type" | translate }}
          </label>
          <p-dropdown
            id="type"
            [options]="typeOptions"
            optionLabel="label"
            optionValue="value"
            formControlName="Type"
            placeholder="Select type"
            [disabled]="isEditMode"
          ></p-dropdown>
        </div>

        <div class="field">
          <label for="priceType" class="control-label required">
            {{ "i18n.domain.subscription.fields.priceType" | translate }}
          </label>
          <p-dropdown
            id="priceType"
            [options]="priceTypeOptions"
            formControlName="priceType"
            optionLabel="label"
            optionValue="value"
            placeholder="Select Price Type"
            [appendTo]="'body'"
            [autoZIndex]="true"
            [scrollHeight]="'200px'"
          ></p-dropdown>
        </div>

        <div class="field">
          <label for="tierLevel" class="control-label required">{{
            "i18n.domain.subscription.fields.tyerlevel" | translate
          }}</label>
          <input
            id="tierLevel"
            pInputText
            type="number"
            formControlName="tierLevel"
            min="1"
            [attr.disabled]="isEditMode ? true : null"
          />
        </div>

        <div class="field-checkbox" class="control-label required">
          <p-checkbox
            formControlName="status"
            binary="true"
            inputId="status"
          ></p-checkbox>
          <label for="status">
            {{ "i18n.domain.subscription.fields.status" | translate }}
          </label>
        </div>
      </form>
    </ng-template>

    <ng-template pTemplate="footer">
      <p-button
        label="{{ 'i18n.shared.cancel' | translate }}"
        icon="pi pi-times"
        [text]="true"
        (onClick)="hideDialog()"
      ></p-button>

      <p-button
        label="{{ 'i18n.shared.save' | translate }}"
        icon="pi pi-check"
        [text]="true"
        (onClick)="saveSubscription()"
        [disabled]="!form.valid"
      ></p-button>
    </ng-template>
  </p-dialog>

  <p-dialog
    [(visible)]="usersDialog"
    [style]="{ width: '80vw' }"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [baseZIndex]="10000"
    styleClass="p-fluid users-dialog"
  >
    <ng-template pTemplate="header">
      <div class="dialog-header">
        <span class="dialog-title">
          {{ subscription?.name }} Assigned Users
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="content">
      <div class="data-table users-inner-table">
        <p-toolbar>
          <ng-template pTemplate="right">
            <app-search-field
              (searchTextChanged)="onUserSearchTextChanged($event)"
            ></app-search-field>
          </ng-template>
        </p-toolbar>

        <p-table
          [value]="subscriptionUsers"
          [rows]="userPagedQuery.pageSize"
          [paginator]="true"
          paginatorDropdownAppendTo="body"
          [globalFilterFields]="[
            'firstname',
            'lastname',
            'email',
            'client.name',
            'roles',
          ]"
          [rowHover]="true"
          dataKey="userId"
          [lazy]="true"
          (onFilter)="onUserFilter($event)"
          (onPage)="onUserPageChange($event)"
          (onSort)="onUserSort($event)"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Users"
          [showCurrentPageReport]="true"
          [totalRecords]="userTotalNoOfRecords"
          [rowsPerPageOptions]="userPagedQuery.getPageSizes()"
          [filterDelay]="0"
          [filters]="userColumnFilters"
          styleClass="dt-grid"
        >
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="firstname">
                {{ "i18n.domain.subscription.fields.firstname" | translate }}
                <p-sortIcon field="firstname"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="firstname"
                  display="menu"
                  [matchModeOptions]="filterMatchModeOptions"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="lastname">
                {{ "i18n.domain.subscription.fields.lastname" | translate }}
                <p-sortIcon field="lastname"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="lastname"
                  display="menu"
                  [matchModeOptions]="filterMatchModeOptions"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="email">
                {{ "i18n.domain.subscription.fields.email" | translate }}
                <p-sortIcon field="email"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="email"
                  display="menu"
                  [matchModeOptions]="filterMatchModeOptions"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="client.name">
                {{ "i18n.domain.subscription.fields.client" | translate }}
                <p-sortIcon field="client.name"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="client.name"
                  display="menu"
                  [matchModeOptions]="filterMatchModeOptions"
                ></p-columnFilter>
              </th>
              <th pSortableColumn="roles">
                {{ "i18n.domain.subscription.fields.role" | translate }}
                <p-sortIcon field="roles"></p-sortIcon>
                <p-columnFilter
                  type="text"
                  field="roles"
                  display="menu"
                  [matchModeOptions]="filterMatchModeOptions"
                ></p-columnFilter>
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-user>
            <tr>
              <td>{{ user.firstname }}</td>
              <td>{{ user.lastname }}</td>
              <td>{{ user.email }}</td>
              <td>{{ user.client?.name }}</td>
              <td>{{ getRoleLabels(user.roles) }}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="5">No Users found</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </ng-template>
  </p-dialog>
</div>
